import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectBrokerSelfRequestFormWidgetActive } from '../../selectors/brokerSelfRequestFormWidget';
import { BrokerSelfRequestFormWidgetAdapterLoadable } from './BrokerSelfRequestFormWidgetAdapterLoadable';

export const BrokerSelfRequestFormWidgetContainer: React.FC = () => {
  const active = useSelector(selectBrokerSelfRequestFormWidgetActive);

  if (!active) {
    return null;
  }

  return <BrokerSelfRequestFormWidgetAdapterLoadable />;
};
